import React from 'react'

const Trash = props => (
  <svg
    width='22'
    height='24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <defs>
      <path
        d='M17.833 20.487H6.167V7.296H4.5v13.947c0 .418.373.757.833.757h13.334c.46 0 .833-.339.833-.757V7.296h-1.667v13.191zm3.334-13.191c.46 0 .833-.34.833-.757 0-.418-.373-.756-.833-.756H2.833c-.46 0-.833.338-.833.756s.373.757.833.757h18.334zm-10 9.273c0 .492.373.892.833.892.46 0 .833-.4.833-.892v-5.355c0-.493-.373-.892-.833-.892-.46 0-.833.4-.833.892v5.355zm-3.334 0c0 .492.373.892.834.892.46 0 .833-.4.833-.892v-5.355c0-.493-.373-.892-.833-.892-.46 0-.834.4-.834.892v5.355zm6.667 0c0 .492.373.892.833.892.46 0 .834-.4.834-.892v-5.355c0-.493-.373-.892-.834-.892-.46 0-.833.4-.833.892v5.355zm-5-13.056h5v2.27h1.667V2.757c0-.418-.373-.757-.834-.757H8.667c-.46 0-.834.339-.834.757v3.026H9.5v-2.27z'
        id='Trasha'
      />
    </defs>
    <g transform='translate(-2 -2)' fill='none' fillRule='evenodd'>
      <path d='M0 0h24v24H0z' />
      <mask id='Trashb' fill='#fff'>
        <use xlinkHref='#Trasha' />
      </mask>
      <path d='M0 0h100v40H0z' mask='url(#Trashb)' fill='#2D3030' />
    </g>
  </svg>
)

export default Trash



// WEBPACK FOOTER //
// ./src/svg-icons/Trash.js